import omitBy from 'lodash/omitBy'

/**
 * @param text, e.g. `player_ref_key__icontains:"sdfsdf" land_i_contains:"fdsfsf"`
 * @param allSuggestions
 * @returns {object}, e.g. {player_ref_key__icontains: 'sdfsdf', land__icontains: 'fdsfsf}
 */
export const convertSearchTextToQuery = (text, locationQuery) => {
  let queriesObj = {}
  const searchTokens = []
  text
    .split(' ')
    .filter((entity) => entity)
    .forEach((query) => {
      if(query.match(/.*:".*"/g)) {
        let [key, ...value] = query.split(':');
        queriesObj[key] = value.join(":").slice(1, -1);  
      } else {
        searchTokens.push(query)
      }      
    })
  return omitBy({
    ...queriesObj,
    ordering: locationQuery.ordering, // keep ordering in the url
    search: searchTokens.join(' ')
  }, (value, key) => !value)
}

/**
 * @param queriesObj {object} - e.g. {text: "data"}
 * @returns {string} - "text:data"
 */
export const convertQueryToSearchText = (queriesObj) => {
  return Object.keys(queriesObj)
    .map((key) => {
      if (key === 'ordering') {
        return ''
      }
      if (key === 'search') {
        return queriesObj[key]
      }
      if (queriesObj[key].startsWith('"')) {
        return `${key}:${queriesObj[key]}`
      }
      return `${key}:"${queriesObj[key]}"`
    })
    .join(' ')
}



// WEBPACK FOOTER //
// ./src/components/Search/SearchHelpers.js